import Vue from 'vue'
import Router from 'vue-router'
import DPSCalc from "../pages/DPSCalc";
import About from "../pages/About";
import Roadmap from "../pages/Roadmap";
import GearUpgrade from "../pages/GearUpgrade";
import MarginsRealtime from "../pages/MarginsRealtime";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: DPSCalc,
      meta: {
        title: 'DPS Calculator'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        title: 'About'
      }
    },
    {
      path: '/roadmap',
      name: 'Roadmap',
      component: Roadmap,
      meta: {
        title: 'Roadmap'
      }
    },
    {
      path: '/margins/realtime',
      name: 'Realtime Margins',
      component: MarginsRealtime,
      meta: {
        title: 'Realtime Margins'
      }
    },
    {
      path: '/calculators/dps-calc',
      name: 'DPSCalc',
      component: DPSCalc,
      meta: {
        title: 'DPS Calculator'
      }
    },
    {
      path: '/calc/compare-dps',
      name: 'DPS Comparison Calculator',
      component: DPSCalc,
      meta: {
        title: 'DPS Comparison'
      }
    },
    {
      path: '/calc/gear/optimize',
      name: 'DPS Gear Optimizer',
      component: GearUpgrade,
      meta: {
        title: 'Gear Optimizer'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js